import api from "./api";
import auth from "./auth";

const BASE_SERVICE_URL = "merchant-auth-service";

export default {
    getUsers(param) {
        return new Promise((resolve, reject) => {
            api.post(
                BASE_SERVICE_URL + "/user/list/" + param.page,
                param.payload,
                {
                    Authorization: auth.getToken()
                }
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    createUser(param) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "/user/create", param, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    updateUser(param, uuid) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "/user/update/" + uuid, param, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getCmsModuleOptions() {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "/cms/options", {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getCmsModuleAccess(id) {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "/cms/module-access/" + id, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    getUserDetails(uuid) {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "/user/view/" + uuid, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    deleteUser(param) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "/delete", param, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    activateOrDeactivateUser(param) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "/update-status", param, {
                Authorization: auth.getToken()
            })
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    }
};
